export const appName = 'SuperMon'
export const appDescription = 'Battling card game maker'
